import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTutorials = (_a) => {
  var _b = _a, { size, title = "Tutorials" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "white",
    d: "M4.5 18.75h-3a.75.75 0 110-1.5h3a.75.75 0 110 1.5zm3.954-9.546a.748.748 0 01-.53-.22l-2.121-2.12a.75.75 0 111.06-1.06l2.121 2.121a.75.75 0 01-.53 1.28zM18 5.25a.75.75 0 01-.75-.75v-3a.75.75 0 111.5 0v3a.75.75 0 01-.75.75zm9.546 3.954a.75.75 0 01-.53-1.28l2.12-2.122a.75.75 0 111.061 1.06l-2.12 2.123a.747.747 0 01-.531.22zM34.5 18.75h-3a.75.75 0 110-1.5h3a.75.75 0 110 1.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M21.75 30.75h-7.5v-3.759c-4.003-1.67-6.506-5.85-5.913-10.29.637-4.776 4.84-8.449 9.659-8.451 5.378-.002 9.754 4.373 9.754 9.75a9.764 9.764 0 01-6 8.991v3.759z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M18 35.25a3.75 3.75 0 01-3.75-3.75v-2.25h7.5v2.25A3.75 3.75 0 0118 35.25z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#2C3C4D",
    d: "M21.75 29.25h-7.5v1.5h7.5v-1.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#435261",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M24 19a6.98 6.98 0 00-2-4.899 7.016 7.016 0 00-2.108-1.478"
  }));
};
var Tutorials = withIcon(SvgTutorials);

export { Tutorials as default };
//# sourceMappingURL=Tutorials.es.js.map
